export var GlobalEvents;
(function (GlobalEvents) {
    GlobalEvents["updateShoppingCartShortcutEvent"] = "update-shopping-cart-shortcut-event";
    GlobalEvents["updateCustomerNotificationsSetEvent"] = "update-customer-notifications-set-event";
    GlobalEvents["RETRIEVED_USER_AUTHORIZATION_ORGANIZATIONS"] = "retrieved-user-authorization-organizations";
    GlobalEvents["SELECTED_USER_AUTHORIZATION_ORGANIZATION"] = "selected-user-authorization-organization";
    GlobalEvents["OPENED_ORGANIZATION_SELECTION"] = "open-organization-selection";
    GlobalEvents["updateGetUserDetailsEvent"] = "update-get-user-details-Event";
})(GlobalEvents || (GlobalEvents = {}));
